module.exports = __webpack_public_path__ + "static/favicon-d811b61119bd98ec2518939e56e7bf08.ico";